import { render, staticRenderFns } from "./BottomSheetAcceptNotifications.vue?vue&type=template&id=27954d72&scoped=true&"
import script from "./BottomSheetAcceptNotifications.vue?vue&type=script&lang=js&"
export * from "./BottomSheetAcceptNotifications.vue?vue&type=script&lang=js&"
import style0 from "./BottomSheetAcceptNotifications.vue?vue&type=style&index=0&id=27954d72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27954d72",
  null
  
)

component.options.__file = "BottomSheetAcceptNotifications.vue"
export default component.exports